import React, { useContext, useEffect, useState } from "react";
import YoutubeApi from "./server";
import SidebarField from "../../../Components/SidebarField";
import { RiVideoUploadLine } from "react-icons/ri";
import { FcGoogle } from "react-icons/fc";
import { toast } from "react-toastify";
import LoaderContext from "../../../Components/loader";

const YouTubeUploader = ({
  setUploadVisible,
  setYturl,
  setStatusPublic,
  statusPublic,
  isUpdate,
  videoIds,
  index,
}) => {
  const [videoFile, setVideoFile] = useState(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [uploadStatus, setUploadStatus] = useState("");
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [videoPreview, setVideoPreview] = useState(null);
  const [videoName, setVideoName] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isUploadProgress, setUploadProgress] = useState(0);

  const { handleLoading } = useContext(LoaderContext);

  const getAuthUrl = async () => {
    try {
      const { data } = await YoutubeApi.youtubeAuth();
      window.location.href = data?.data?.authUrl;
    } catch (error) {
      console.error("Error fetching auth URL:", error);
      setUploadStatus("Failed to initiate authentication.");
    }
  };

  const getToken = async () => {
    try {
      const res = await YoutubeApi.getOauthToken();
      if (res.status === 201) {
        toast.error("Login credentials failed");
        setUploadStatus("Failed to initiate authentication.");
        setIsLoggedIn(false);
      } else if (res.status === 200) {
        setIsLoggedIn(true);
        // toast.success("Login successfully");
      }
    } catch (error) {
      console.error("Error fetching auth URL:", error);
      setUploadStatus("Failed to initiate authentication.");
    }
  };

  useEffect(() => {
    getToken();
  }, []);

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setVideoPreview(URL.createObjectURL(file));
      setVideoName(file.name);
      setVideoFile(e.target.files[0]);
    }
  };

  const uploadVideo = async () => {
    handleLoading(true);
    setIsLoading(true);

    if (!videoFile || !title) {
      setUploadStatus("Please select a video file and enter a title.");
      handleLoading(false);
      setIsLoading(false);
      toast.error("Please select a video file and enter a title.");
      return;
    }

    const formData = new FormData();
    formData.append("video", videoFile);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("tags", JSON.stringify(["react", "youtube"]));
    formData.append("privacyStatus", statusPublic ? "public" : "private");

    let dummyProgress = 0;
    const progressInterval = setInterval(() => {
      if (dummyProgress < 100) {
        dummyProgress += 1;
        setUploadProgress(dummyProgress);
      }
    }, 100);

    try {
      const response = await YoutubeApi.youtubeUpload(formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      setYturl((prev) => ({
        ...prev,
        intro: statusPublic ? response.data?.data?.videoId : prev.intro,
        syllabus: {
          ...prev.syllabus,
          [index]: !statusPublic ? response.data?.data?.videoId : prev.syllabus,
        },
        // syllabus: !statusPublic ? response.data?.data?.videoId : prev.syllabus,
      }));

      // await new Promise((resolve) => setTimeout(resolve, 30000));
      clearInterval(progressInterval);
      if (response.data.success) {
        toast.success("Video uploaded successfully");
        setUploadStatus("Video uploaded successfully!");
      } else {
        toast.error("Failed to upload video");
        setUploadStatus("Failed to upload video.");
      }
    } catch (error) {
      console.error("Error uploading video:", error);
      setUploadStatus("An error occurred during video upload.");
    } finally {
      handleLoading(false);
      setIsLoading(false);
      setVideoPreview(null);
      setVideoFile(null);
      setDescription("");
      setTitle("");
      setStatusPublic(false);
      clearInterval(progressInterval);
      setUploadVisible(false);
    }
  };

  return (
    <SidebarField handleClose={() => setUploadVisible(false)}>
      <div className="relative flex flex-col items-center justify-center bg-white font-roboto ">
        {isLoading && (
          <div className="absolute inset-0 z-50 flex items-center justify-center bg-white bg-opacity-50">
            <div className="flex flex-col items-center">
              <div
                className="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin"
                role="progressbar"
              ></div>
              <p className="text-black mt-4 font-medium">
                Uploading... {isUploadProgress}%
              </p>
            </div>
          </div>
        )}
        {!isLoggedIn ? (
          <div className="bg-white p-6 w-full h-full flex flex-col items-center justify-center">
            <h2 className="text-2xl font-bold mb-4">Login to Your Account</h2>
            <button
              onClick={getAuthUrl}
              className="bg-white flex text-black items-center gap-3 border border-gray-400 rounded-sm px-4 py-2"
            >
              <FcGoogle className="text-xl" />
              Login with Google
            </button>
            {uploadStatus && (
              <p className="text-red-500 mt-4">{uploadStatus}</p>
            )}
          </div>
        ) : (
          <div className="w-full bg-white h-full gap-4 flex flex-col pr-8 pl-8 items-center">
            <h2 className="text-2xl font-semibold text-white-800 mb-4">
              {title ? title : "New Video"}
            </h2>

            <div className="w-full mb-4 flex flex-col items-center justify-center h-60 border-2 border-dashed border-gray-300 bg-white text-black">
              {videoPreview ? (
                <div className="w-full h-full flex flex-col items-center justify-center">
                  <video
                    src={videoPreview}
                    controls
                    className="w-full h-48 mb-2"
                  />
                  <p className="text-xs text-gray-400">{videoName}</p>
                </div>
              ) : (
                <>
                  <label
                    className="text-sm font-medium  flex flex-col items-center cursor-pointer"
                    htmlFor="YT-video"
                  >
                    <RiVideoUploadLine className="text-4xl" />
                    <p className="text-lg font-semibold">Select video file</p>
                    <p className="text-xs text-gray-400 mb-4 justify-evenly">
                      Maximum 100MB. Preferred format is MP4 (H.264) or WEBM
                      (VP8, VP9)
                    </p>
                    <p className="text-xs text-gray-400 mb-4 justify-evenly">
                      Your videos will be private until you publish them.
                    </p>
                  </label>
                </>
              )}

              {videoPreview && (
                <div className="flex w-full justify-between pl-10 pr-10">
                  <label htmlFor="YT-video" className="cursor-pointer">
                    Re-upload
                  </label>
                  <button
                    onClick={() => {
                      setVideoPreview("");
                      setVideoFile(null);
                    }}
                    className="border-none"
                  >
                    Cancel
                  </button>
                </div>
              )}

              <input
                type="file"
                accept="video/*"
                id="YT-video"
                onChange={handleFileChange}
                className="w-full border hidden border-gray-300 rounded-lg px-3 py-2 focus:outline-none "
              />
            </div>
            <div className="w-full mb-4">
              <input
                type="text"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                id="video-title"
                placeholder="Add a title that describes your video"
                autoComplete={false}
                className="w-full rounded-lg text-xl text-[#3a90da]  font-bold py-2 focus:outline-none"
              />
            </div>
            <div className="w-full mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Description (optional)
              </label>
              <textarea
                value={description}
                onChange={(e) => setDescription(e.target.value)}
                placeholder="Tell about your video"
                rows="4"
                className="w-full min-h-20 border border-gray-300 px-3 py-2 focus:outline-none"
              />
            </div>

            <button
              onClick={uploadVideo}
              className={`w-full ${
                isLoading
                  ? "bg-gray-500 cursor-not-allowed"
                  : "bg-[#3a90da] hover:bg-blue-700  transition"
              }  text-white font-semibold py-2`}
              disabled={isLoading}
            >
              Upload & publish
            </button>
            {uploadStatus && (
              <p
                className={`mt-4 text-center font-medium ${
                  uploadStatus.includes("success")
                    ? "text-green-600"
                    : "text-red-600"
                }`}
              >
                {uploadStatus}
              </p>
            )}
          </div>
        )}
      </div>
    </SidebarField>
  );
};

export default YouTubeUploader;
